const getI = (sec: number) => {
    return { '--i' : `${sec}s`} as React.CSSProperties
}

export default getI 